import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CurrencyPipe } from '@angular/common';
import { ARService } from '../../ar.service';
import { ArCardPaymentComponent } from '../ar-card-payment/ar-card-payment.component';
import { ArPaymentInvoiceGeneratorComponent } from '../ar-payment-invoice-generator/ar-payment-invoice-generator.component';
import { dataARLedger, dataContact, dataPatient, enumValidValueItem } from '../../_models/ar.models';
import { TdoTableV2Component } from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableFooterDataModel } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { DataARLedgerListModel } from '../../models/data-ar-ledger-list.model';
import { CfgARAccountModel } from '../../../../models/accountsReceivable/cfg-ar-account.model';
import { CreatePaymentModel } from '../../models/create-payment.model';
import { Globals } from '../../../../globals';
import { DataARPaymentModel } from '../../../../models/accountsReceivable/data-ar-payment.model';
import { MessagingService } from '../../../../services/messaging.service';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { ArPaymentCancelComponent } from '../ar-payment-cancel/ar-payment-cancel.component';
import { SavePaymentDistributionsModel } from '../../models/save-payment-distributions.model';
import { PaymentProcessorConfigurationService } from '../../../configuration/payment-processor-configuration/payment-processor-configuration..service';
import { PaymentProcessorDeviceListModel } from '../../../configuration/models/payment-processor-device-list.model';
import { CfgARPaymentProcessorModel } from '../../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { CreateLedgerItemForPaymentModel } from '../../models/create-ledger-item-for-payment.model';
import { DataARLedgerModel } from '../../../../models/accountsReceivable/data-ar-ledger.model';
import { DataARPaymentDistribsModel } from '../../../../models/accountsReceivable/data-ar-payment-distribs.model';
import { CfgARPaymentMethodModel } from '../../../../models/accountsReceivable/cfg-ar-payment-method';
import { PaymentMethodConfigurationService } from '../../../configuration/payment-method-configuration/payment-method-configuration.service';
import { ArLedgerItemSelectComponent } from '../../ledger/ar-ledger-item-select/ar-ledger-item-select.component';
import { PaymentAmountForDoctorModel } from '../../models/payment-amount-for-doctor.model';
import { DataArPaymentToken } from '../../../../models/accountsReceivable/data-ar-cc-payment-token';
import { ITDOPaymentTransactionResult } from '@tdo-inc/tdo-payment';
import { ArPaymentTokenConsentComponent } from '../ar-payment-token-consent/ar-payment-token-consent.component';
import { CreditCardTokenPaymentResponse } from '../../../../models/accountsReceivable/credit-card-token-payment-response';
import { PrintCCReceiptModel } from 'src/app/models/accountsReceivable/PrintCCReceipt.model';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { EnumARPaymentType } from 'src/app/models/enum/enum-ar-payment-type';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-ar-payment',
    templateUrl: './ar-payment.component.html',
    styleUrls: ['./ar-payment.component.scss']
})
export class ArPaymentComponent implements OnInit {

    @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
    searchPredicate: (data: any, filter: string) => boolean;
    footerData: TdoTableFooterDataModel[] = [];

    messagingSubscription: any;
    applyPayment: boolean = false;
    hideNoBalanceItems: boolean = false;
    type: string;
    dataContact: dataContact;
    dataPatient: dataPatient;
    dataLedgerItems: DataARLedgerListModel[] = [];
    dataCreditLedgerItems: DataARLedgerListModel[] = [];

    arAccounts: CfgARAccountModel[] = [];
    arAccountsAll: CfgARAccountModel[] = [];
    paymentMethods: CfgARPaymentMethodModel[] = [];
    paymentCCSources: enumValidValueItem[] = [];
    paymentESources: enumValidValueItem[] = [];
    paymentESourcesMaster: enumValidValueItem[] = [];
    paymentTypes: enumValidValueItem[] = [];
    contactList: dataContact[] = [];
    ledgerItems: dataARLedger[] = [];
    isLoading: boolean = false;
    ispaymentLoading: boolean = false;
    paymentDevices: PaymentProcessorDeviceListModel[] = [];
    paymentProcessors: CfgARPaymentProcessorModel[] = [];
    paymentTokens: DataArPaymentToken[] = [];
    selectedToken: DataArPaymentToken;
    initializeToken: boolean = false;
    saveCCInfo: number = 0;
    verbalConsentInfo: string;

    DocPaymentProcessors: CfgARPaymentProcessorModel[] = [];

    PaymentAmountForDoctors: PaymentAmountForDoctorModel[];

    paymentAmount: number = 0;
    paymentAmountNotDistributed: number = 0;
    approvedPaymentAmount: number = 0;
    selectedPaymentMethod: CfgARPaymentMethodModel;
    selectedPaymentType: enumValidValueItem;
    selectedEPaymentType: enumValidValueItem;
    selectedCCPaymentType: enumValidValueItem;
    selectedContact: dataContact;
    paymentDescription: string;
    datePostPayment: Date;
    datePaymentReceived: Date;
    dateReceivedPayment: Date;
    dateReceivedMin: Date;
    currentARPayment: DataARPaymentModel;
    currentTransactionSetupID: string;
    currentTransactionID: string;
    depositARAccountID: string;
    currentWorkStationID: string;
    creditRemainingAmount: boolean = false;
    selectedLedgerItem: DataARLedgerListModel;
    saveButtonCaption: string = 'Save Payment';
    currentPaymentProcessorId: string;

    enumPaymentTransactionTypeIDPurchase: string = '00000277-1000-0000-0000-000000000001';

    enumEPayTypeCredit: string = '00000082-1000-0000-0000-000000000001';
    enumLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
    enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';
    enumPaymentSource: string = '';
    enumCurrencyUSD: string = '00000192-1000-0000-0000-000000000001';

    enumPaymentETypeCreditCard: string = '00000082-1000-0000-0000-000000000001';
    enumPaymentETypeDebitCard: string = '00000082-1000-0000-0000-000000000002';
    enumPaymentETypeCareCredit: string = '00000082-1000-0000-0000-000000000004';
    enumPaymentETypeECheck: string = '00000082-1000-0000-0000-000000000005';

    submitPaymentInSuccess = false;
    creditPaymentClicked = false;
    isPrintingReceipt: boolean = false;
    readonly LEDGER_ITEM_TYPE = LEDGER_ITEM_TYPE;
    readonly EnumARPaymentType = EnumARPaymentType;
    isDisabledReceivedDate: boolean;

    constructor(
        public dialogRef: MatDialogRef<ArPaymentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly arService: ARService,
        private readonly ppService: PaymentProcessorConfigurationService,
        private readonly localStorageService: LocalStorageService,
        private readonly currencyPipe: CurrencyPipe,
        private readonly dialog: MatDialog,
        private readonly globals: Globals,
        private readonly messagingService: MessagingService,
        private readonly changeDet: ChangeDetectorRef,
        private readonly paymentMethodConfigService: PaymentMethodConfigurationService,
        private readonly printService: TDOPrintService,
        private readonly toastr: ToastrService
    ) {
        this.searchPredicate = (ledgerData: DataARLedgerListModel, filter: string) => {
            if (ledgerData.dataARTransactionItem) {
                return ledgerData.dataARTransactionItem.Code.toLowerCase().includes(filter)
                    || ledgerData.Description.toLowerCase().includes(filter);
            }
            return ledgerData.Description.toLowerCase().includes(filter);
        };
    }

    ngOnInit() {

        this.isLoading = true;

        this.type = this.data.type;
        this.ledgerItems = this.data.ledgerItems;
        this.dataPatient = this.data.dataPatient;
        this.dataContact = this.data.dataContact;
        this.dataLedgerItems = this.data.dataLedgerItems;
        this.dataCreditLedgerItems = this.data.dataLedgerItems;
        this.clearSelectedItems();

        if (this.type === 'Patient') {
            this.enumPaymentSource = PAYMENT_SOURCE.Patient; // payment from patient
        } else {
            this.enumPaymentSource = PAYMENT_SOURCE.Insurance; // payment from insurance
        }

        this.datePostPayment = new Date();
        this.dateReceivedPayment = new Date();

        this.selectedContact = this.dataContact;
        this.contactList = [this.dataContact];

        this.dataPatient.dataPatientContacts.forEach(dataPatientContact => {
            console.log('Datapatientcontact: ', dataPatientContact);
            if (dataPatientContact.dataContact?.FirstName !== null || !dataPatientContact.dataContact?.LastName !== null) {
                console.log('Datapatientcontact Added: ', dataPatientContact);
                this.contactList.push(dataPatientContact.dataContact);
            }
        });

        // listener for approved cc transaction
        // this.messagingSubscription = this.messagingService.componentMessageCall.subscribe(
        //     response => {

        //         // if (response.event === MessagingConstants.AR_WORLDPAY_PAYMENT_APPROVED) {
        //         //     // world pay payment approved
        //         //     this.approvedPaymentAmount = response.data.approvedAmount;
        //         //     this.currentTransactionSetupID = response.data.transactionSetupID;
        //         //     this.paymentAmountNotDistributed = this.approvedPaymentAmount;

        //         //     // disable top half of screen
        //         //     this.applyPayment = true;

        //         //     // reset payments
        //         //     this.resetApplyPaymentAmounts();

        //         //     // auto apply payment
        //         //     this.autoApplyRemaining();
        //         // }
        //         // else if (response.event === MessagingConstants.AR_WORLDPAY_PAYMENT_CANCELED) {
        //         //     // world pay payment canceled
        //         //     this.approvedPaymentAmount = 0;
        //         //     this.currentTransactionSetupID = response.data.transactionSetupID;
        //         //     this.paymentAmountNotDistributed = 0;

        //         //     // disable top half of screen
        //         //     this.applyPayment = false;

        //         //     // reset payments
        //         //     this.resetApplyPaymentAmounts();
        //         // }
        //         // else if (response.event === MessagingConstants.AR_TRIPOS_PAYMENT_APPROVED) {
        //         //     // world pay payment approved
        //         //     this.approvedPaymentAmount = response.data.approvedAmount;
        //         //     this.currentTransactionID = response.data.transactionID;
        //         //     this.paymentAmountNotDistributed = this.approvedPaymentAmount;
        //         //     this.paymentAmount = response.data.transactionAmount;
        //         //     this.paymentDescription = response.data.transactionDescription;

        //         //     // disable top half of screen
        //         //     this.applyPayment = true;

        //         //     // reset payments
        //         //     this.resetApplyPaymentAmounts();

        //         //     // auto apply payment
        //         //     this.autoApplyRemaining();
        //         // }
        //         // else if (response.event === MessagingConstants.AR_TRIPOS_PAYMENT_CANCELED) {
        //         //     // world pay payment canceled
        //         //     this.approvedPaymentAmount = 0;
        //         //     this.paymentAmountNotDistributed = 0;
        //         //     this.paymentAmount = response.data.transactionAmount;
        //         //     this.paymentDescription = response.data.transactionDescription;

        //         //     // disable top half of screen
        //         //     this.applyPayment = false;

        //         //     // reset payments
        //         //     this.resetApplyPaymentAmounts();
        //         // }
        //     }
        // );

        // filter ledger items to debit
        this.dataLedgerItems = this.dataLedgerItems.filter(a => a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Outstanding
            && a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit && a.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypePatient
            && a.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void);

        // filter ledger items where credit
        this.dataCreditLedgerItems = this.dataCreditLedgerItems.filter(
            a => a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Outstanding
                && (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditAdjustment
                    || a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditAdjustmentInsurance
                    || a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditCreatedFromPaymentVoid));

        this.returnValidPaymentTokens();

        this.init();
    }

    createDataARPaymentRecord() {
        const promise = new Promise((resolve, reject) => {

            const createPayment = new CreatePaymentModel();
            createPayment.datePostPayment = this.datePostPayment;
            createPayment.dateReceivedPayment = this.dateReceivedPayment;
            createPayment.Description = this.paymentDescription;
            createPayment.enumPaymentSourceID = PAYMENT_SOURCE.Patient;
            createPayment.PatientID = this.globals.currentPatientId;
            createPayment.paymentAmount = this.paymentAmount;
            createPayment.PaymentFrom = null;
            createPayment.PaymentFromContactID = this.selectedContact ? this.selectedContact.ContactId : null;
            createPayment.enumCurrencyID = this.enumCurrencyUSD;
            createPayment.DepositARAccountID = this.depositARAccountID;
            createPayment.enumPaymentTransactionTypeID = this.enumPaymentTransactionTypeIDPurchase;
            createPayment.LOCID = this.globals.LOCID;
            createPayment.PaymentProcessorID = this.currentPaymentProcessorId;

            if (this.selectedPaymentMethod) {
                createPayment.enumARPayementCCTypeID = this.selectedPaymentMethod.enumARPayementCCTypeID ? this.selectedPaymentMethod.enumARPayementCCTypeID : null;
                createPayment.enumARPayementETypeID = this.selectedPaymentMethod.enumARPayementETypeID ? this.selectedPaymentMethod.enumARPayementETypeID : null;
                createPayment.enumARPayementTypeID = this.selectedPaymentMethod.enumARPayementTypeID ? this.selectedPaymentMethod.enumARPayementTypeID : null;
            }

            // if credit payment
            if (this.selectedLedgerItem) {
                // we are assuming that this is a patient credit payment
                createPayment.enumPaymentSourceID = PAYMENT_SOURCE.ApplyCredit;
                createPayment.PaymentSourceObjectID = this.selectedLedgerItem.LedgerID;
                createPayment.enumARPayementCCTypeID = null;
                createPayment.enumARPayementETypeID = null;
                createPayment.enumARPayementTypeID = EnumARPaymentType.InternalCredit;
            }

            this.arService.createDataARPaymentRecord(createPayment)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    createLedgerItemForPayment() {
        const promise = new Promise((resolve, reject) => {

            const payload = new CreateLedgerItemForPaymentModel();
            payload.PaymentID = this.currentARPayment.PaymetnID;
            payload.enumARLedgerItemOriginTypeID = this.enumLedgerItemOriginTypePatient;
            payload.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditPayment;
            // payload.

            // if credit is being applied
            if (this.selectedLedgerItem) {
                payload.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditPaymentFromPatientCredit;
            }

            this.arService.createLedgerItemForPayment(payload)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    savePaymentDistributionClicked() {
        this.isLoading = true;
        this.savePaymentDistribution(this.dataLedgerItems.filter(a => a.ApplyPayment > 0)).then((result: number) => {
            if (result) {
                if (result === 1) {
                    this.createMessage('Payment distribution succeeded', 'Success');

                    if (this.paymentAmountNotDistributed > 0) {
                        this.createCreditForUndistributedPayment();
                    }
                    else {
                        this.close(true);
                    }
                }
            }
        }, err => {
            this.createMessage('Problem distributing payment', 'Error');
            this.isLoading = false;
        });
    }

    savePaymentDistribution(ledgerItems: DataARLedgerListModel[]) {
        const promise = new Promise((resolve, reject) => {
            const savePaymentDistributionModel = new SavePaymentDistributionsModel();
            savePaymentDistributionModel.dataARLedgerItems = ledgerItems;
            savePaymentDistributionModel.PaymentID = this.currentARPayment.PaymetnID;
            savePaymentDistributionModel.ClientPostDate = new Date();
            savePaymentDistributionModel.LOCID = parseInt(localStorage.getItem('LOCID'));

            // pass ledger item to void, if credit was used
            if (this.selectedLedgerItem) {
                savePaymentDistributionModel.LedgerItemToVoid = this.selectedLedgerItem.LedgerID; // is this right?
            }

            this.arService.savePaymentDistributions(savePaymentDistributionModel)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    autoApplyRemaining() {
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);

        let amountRemaining = this.paymentAmountNotDistributed;
        this.dataLedgerItems.every(ledgerItem => {
            let amountDue = 0;
            if (this.selectedLedgerItem || ledgerItem.ARAccountID === payDr.ARAccountID)     // zoli Valpay
            {
                if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
                    amountDue += this.returnAmountDue(ledgerItem);

                    // try to apply payment
                    if (amountDue <= amountRemaining && amountRemaining > 0) {
                        ledgerItem.ApplyPayment = amountDue;
                        amountRemaining = amountRemaining - amountDue;
                    } else {
                        ledgerItem.ApplyPayment = amountRemaining;
                        amountRemaining = 0;
                        this.paymentAmountNotDistributed = amountRemaining;
                        return false;
                    }

                    // update remaining
                    this.paymentAmountNotDistributed = amountRemaining;
                }
            }
            return true;
        });
    }

    returnAmountDue(ledgerItem: DataARLedgerListModel) {

        let AmountDue = 0;
        if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit && ledgerItem.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypePatient && ledgerItem.enumARLedgerItemTypeID !== LEDGER_ITEM_STATUS.Void) {

            if (ledgerItem.AmountDuePatient) {
                AmountDue = ledgerItem.AmountDuePatient;
            }
        }

        return AmountDue;
    }

    resetApplyPaymentAmounts() {
        this.dataLedgerItems.forEach(ledgerItem => {
            if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
                ledgerItem.ApplyPayment = 0;
            }
        });
    }

    setPaymentAmountDistributionRemaining() {
        let paymentsDistributed = 0;
        this.dataLedgerItems.forEach(ledgerItem => {
            if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
                paymentsDistributed += ledgerItem.ApplyPayment;
            }
        });

        this.paymentAmountNotDistributed = this.approvedPaymentAmount - paymentsDistributed;
    }

    returnAmountDueAll() {
        let amountDue = 0;

        this.dataLedgerItems.forEach(ledgerItem => {

            if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit && ledgerItem.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void) {
                amountDue += this.returnAmountDue(ledgerItem);
            }
        });

        if (this.dataLedgerItems.length > 0) {
            this.PaymentAmountForDoctors = [];
            const am = {} as PaymentAmountForDoctorModel;
            am.DoctorARLocId = this.dataLedgerItems[0].DoctorARLocId;
            am.ARAccountID = this.dataLedgerItems[0].ARAccountID;
            am.DoctorName = this.dataLedgerItems[0].DoctorName;
            am.amount = 0;
            am.isSelected = false;
            this.PaymentAmountForDoctors.push(am);

            this.dataLedgerItems.forEach(ledgerItem => {
                if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit && ledgerItem.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void) {
                    let d = this.PaymentAmountForDoctors.find(f => f.DoctorARLocId == ledgerItem.DoctorARLocId);
                    if (d === undefined) {
                        const a = {} as PaymentAmountForDoctorModel;
                        a.DoctorARLocId = ledgerItem.DoctorARLocId;
                        a.ARAccountID = ledgerItem.ARAccountID;
                        a.DoctorName = ledgerItem.DoctorName;
                        a.amount = 0;

                        a.isSelected = false;
                        this.PaymentAmountForDoctors.push(a);
                        d = this.PaymentAmountForDoctors.find(f => f.DoctorARLocId == ledgerItem.DoctorARLocId);
                    }
                    d.amount += this.returnAmountDue(ledgerItem);
                    if (ledgerItem.DoctorName !== '') {
                        d.DoctorName = ledgerItem.DoctorName;
                    }
                }
            });
            if (this.PaymentAmountForDoctors.length === 1) {
                this.PaymentAmountForDoctors[0].isSelected = true;
                this.depositARAccountID = this.PaymentAmountForDoctors[0].ARAccountID;
            }

            const za = this.PaymentAmountForDoctors.filter(f => f.amount === 0);
            if (za.length > 0) {
                za.forEach(a => {
                    if (this.arAccounts.find(q => q.DoctorARLocId === a.DoctorARLocId).isActiveDoctor === false) {
                        this.PaymentAmountForDoctors.splice(this.PaymentAmountForDoctors.findIndex(item => item.DoctorARLocId === a.DoctorARLocId), 1);
                    }
                });
            }
        }
        else {
            // if no ledger items to charge

            // get list of doctors
            this.PaymentAmountForDoctors = [];


            this.arService.getDoctorsARLocByLOCID(this.globals.LOCID).subscribe(res => {

                for (let i = 0; i < res.length; i++) {

                    const a = {} as PaymentAmountForDoctorModel;
                    a.DoctorARLocId = res[i].DoctorARLocId;
                    a.ARAccountID = res[i].ARAccountID;
                    a.DoctorName = res[i].DoctorName;
                    a.amount = 0;
                    //
                    a.isSelected = false;
                    this.PaymentAmountForDoctors.push(a);
                }
            });
        }
        return amountDue;
    }

    trimName(name: string) {
        if (name && name.length > 20) {
            return name.slice(0, 20);
        }
        return name;
    }

    init() {
        this.currentWorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
        const locid = localStorage.getItem('LOCID');

        const promises = [
            this.paymentMethodConfigService.getPaymentMethodList(locid).toPromise(),
            this.getAllDoctorARLocations(),
            this.getPaymentProcessorDevicesByWorkstation(this.currentWorkStationID, locid),
            this.getPaymentProcessorList(locid),
            this.getAllARAccounts()
        ];

        this.isLoading = true;
        Promise.all(promises).then((results: any[]) => {

            this.paymentMethods = results[0];
            this.arAccounts = results[1];
            this.paymentDevices = results[2];
            this.paymentProcessors = results[3];
            this.selectedPaymentType = this.paymentTypes[0];
            this.arAccountsAll = results[4];


            // set payment amount default
            this.paymentAmount = this.returnAmountDueAll();

            if (this.data.dataARPaymentAudit) {

                // load window for existing payment
                this.paymentAmount = this.data.dataARPaymentAudit.PaymentAmount;
                this.approvedPaymentAmount = this.data.dataARPaymentAudit.ApprovedPaymentAmount;
                this.currentTransactionSetupID = this.data.dataARPaymentAudit.PaymentTransactionId;
                this.paymentAmountNotDistributed = this.data.dataARPaymentAudit.ApprovedPaymentAmount;
                this.datePostPayment = this.data.dataARPaymentAudit.PaymentTransactionDate;
                this.paymentDescription = this.data.dataARPaymentAudit.Description;

                this.currentARPayment = new DataARPaymentModel();
                this.currentARPayment.PaymetnID = this.data.dataARPaymentAudit.PaymetnID;

                const payType = this.paymentTypes.filter(a => a.ValidValueItemId === this.data.dataARPaymentAudit.enumARPayementTypeID);
                if (payType.length) {
                    this.selectedPaymentType = payType[0];
                }

                const payEType = this.paymentESources.filter(a => a.ValidValueItemId === this.data.dataARPaymentAudit.enumARPayementETypeID);
                if (payEType.length) {
                    this.selectedEPaymentType = payEType[0];
                }

                const payCCType = this.paymentCCSources.filter(a => a.ValidValueItemId === this.data.dataARPaymentAudit.enumARPayementETypeID);
                if (payCCType.length) {
                    this.selectedCCPaymentType = payCCType[0];
                }

                const contact = this.contactList.filter(a => a.ContactId === this.data.dataARPaymentAudit.PayamentFromContactID);
                if (contact.length) {
                    this.selectedContact = contact[0];
                }

                // disable top half of screen
                this.applyPayment = true;

                // filter by debit
            }

            this.isLoading = false;
        }, err => {
            this.createMessage('Something went wrong', 'Error');
            this.isLoading = false;
        });

    }

    // Handle selection and deselection of rows model data
    onRowSelected(event: TdoTableSelectionEvent) {
        const ledgerModel = this.dataLedgerItems.find(p => p === event.model);
        if (ledgerModel) {
            ledgerModel.DATA_SELECTED = event.isSelected;
        }
    }

    hasSelectedItems() {
        if (this.dataLedgerItems.filter(item => item.DATA_SELECTED).length) {
            return true;
        }
        else {
            return false;
        }
    }

    sortEnum(enumList: any[]) {
        return enumList.sort((a, b) => a.ItemOrder - b.ItemOrder);
    }

    getEnumValidValueItemsByValidValueName(ValidValueName: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.getEnumValidValueItemsByValidValueName(ValidValueName)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    // calculateCost(ledgerItem: any, billTo: string, debug = false) {

    //     const transactionItem = ledgerItem.dataARTransactionItem;

    //     let doctorFee: number = transactionItem.Price;
    //     let insuranceCoverage: number;
    //     let discountCoverage: number;

    //     if (transactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageTypeAmount) {
    //         insuranceCoverage = transactionItem.CoverageAmount;
    //     } else {
    //         insuranceCoverage = (doctorFee * (transactionItem.CoveragePCT / 100));
    //     }

    //     if (transactionItem.enumFeeDiscountCalcTypeId === this.enumCoverageTypeAmount) {
    //         discountCoverage = transactionItem.DiscountAmount;
    //     } else {
    //         discountCoverage = (doctorFee * (transactionItem.DiscountPCT / 100));
    //     }

    //     if (typeof doctorFee === 'undefined' || isNaN(doctorFee)) {
    //         return 0;
    //     }

    //     if (typeof insuranceCoverage === 'undefined' || isNaN(insuranceCoverage)) {
    //         insuranceCoverage = 0;
    //     }

    //     if (typeof discountCoverage === 'undefined' || isNaN(discountCoverage)) {
    //         discountCoverage = 0;
    //     }

    //     if (billTo === 'insurance') {
    //         ledgerItem.DATA_INSURANCE_COST = insuranceCoverage;
    //         return insuranceCoverage;
    //     } else {

    //         if (discountCoverage) {

    //             if (transactionItem.enumFeeDiscountCalcTypeId === this.enumCoverageTypeAmount) {
    //                 doctorFee = doctorFee - discountCoverage;
    //             } else {
    //                 doctorFee = discountCoverage;
    //             }

    //         }

    //         const billableToPatient = doctorFee - insuranceCoverage;

    //         if (billableToPatient < 0) {
    //             return 0;
    //         }

    //         ledgerItem.DATA_PATIENT_COST = billableToPatient;
    //         return billableToPatient;
    //     }
    // }

    close(payload) {
        this.dialogRef.close(payload);
    }

    convertUTCDateToLocalDateFromString(dateString) {
        if (!dateString) {
            return null;
        }

        const date = new Date(dateString);
        return this.convertUTCDateToLocalDate(date);
    }

    convertUTCDateToLocalDate(date) {
        return new Date(
            Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds()
            )
        );
    }

    clearSelectedItems() {
        this.dataLedgerItems.forEach(item => { item.DATA_SELECTED = false; });
    }

    buildPDFFromPayment(payment, isPaid = true) {

        const promise = new Promise((resolve, reject) => {

            const dialogRef = this.dialog.open(ArPaymentInvoiceGeneratorComponent, {
                width: '90%',
                height: '90%',
                data: {
                    isPaid,
                    paymentId: payment.PaymetnID,
                    dataPatient: this.dataPatient,
                    patientMode: false,
                    LOCID: localStorage.getItem('LOCID'),
                }
            });
            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            }, err => {
                resolve(false);
            });

        });
        return promise;
    }

    saveCurrencyField2(event, fieldName, ledgerID) {
        const inputValue = event.target.value;

        this.dataLedgerItems.forEach(ledgerItem => {
            if (ledgerItem.LedgerID.toUpperCase() === ledgerID.toUpperCase()) {
                const num = Number(inputValue.replace(/[^0-9.-]+/g, ''));

                if (num > ledgerItem.AmountDuePatient) {
                    this.createMessage('Amount entered is more than amount owed', 'Error');
                    return ledgerItem.AmountDuePatient;
                }
                else {
                    return num;
                }
            }
        });
    }

    saveCurrencyField(event, fieldName, ledgerID) {
        const inputValue = event.target.value;

        switch (fieldName) {
            case 'paymentAmount': {
                this.paymentAmount = Number(inputValue.replace(/[^0-9.-]+/g, ''));

                // force change detection
                this.changeDet.detectChanges();

                // per alyson - jira 828
                // should be able to make payment of any amount
                // if (this.paymentAmount > this.returnAmountDueAll()) {
                //   this.createMessage('Amount entered is more than amount owed', 'Error');
                //   this.paymentAmount = this.returnAmountDueAll();
                // }

                // more change detection
                this.changeDet.markForCheck();
                break;
            }
            case 'ApplyPayment': {
                this.dataLedgerItems.forEach(ledgerItem => {
                    if (ledgerItem.LedgerID.toUpperCase() === ledgerID.toUpperCase()) {
                        const num = Number(inputValue.replace(/[^0-9.-]+/g, ''));
                        const numAmountDue = Number(ledgerItem.AmountDuePatient);
                        const prevValue = ledgerItem.ApplyPayment;
                        ledgerItem.ApplyPayment = num;

                        // given change, get new amount not/distributed
                        let amountDistributed = 0;
                        //let amountNotDistributed = 0;
                        this.dataLedgerItems.forEach(li => {
                            if (li.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
                                amountDistributed += li.ApplyPayment;
                            }
                        });
                        //amountNotDistributed = this.paymentAmount - amountDistributed;

                        // force change detection
                        this.changeDet.detectChanges();

                        if (amountDistributed > this.paymentAmount) {
                            ledgerItem.ApplyPayment = prevValue;
                            this.createMessage('Amount entered is more than amount remaining', 'Error');
                        }
                        else if (num > ledgerItem.AmountDuePatient) {
                            ledgerItem.ApplyPayment = numAmountDue;
                            this.createMessage('Amount entered is more than amount owed', 'Error');
                        }
                        else {
                            ledgerItem.ApplyPayment = num;
                        }

                        // update tdo table model
                        this.tdoTable.dataSource = this.dataLedgerItems;
                        this.tdoTable.updateData();
                    }
                });
                break;
            }
        }
    }

    createPaymentForLedgerItem(paymentItem: any) {
        const promise = new Promise((resolve, reject) => {
            this.arService.createPaymentForLedgerItem(paymentItem)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    submitPayment(event) {

        // single click for credit
        if (this.selectedLedgerItem) {
            this.creditPaymentClicked = true;
        }

        // prevent double click
        if (this.submitPaymentInSuccess) {
            return;
        }
        this.submitPaymentInSuccess = true;

        this.ispaymentLoading = true;

        // zoli for valpay
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);

        // only do if not a credit
        if (!this.selectedLedgerItem) {
            if (payDr === undefined || payDr.amount === 0) {
                this.submitPaymentInSuccess = false;
                this.createMessage('Please enter an amount !', 'Stop');
                return;
            }
            this.paymentAmount = payDr.amount;
        }

        this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {
            this.ispaymentLoading = false;
            if (newPayment) {

                // cfgARPayment record created
                // record new payment
                this.currentARPayment = newPayment;

                // if electronic
                if (this.currentARPayment.enumARPayementTypeID === EnumARPaymentType.CreditCard) {
                    newPayment.PaymentProcessorId = payDr.PaymentProcessorId;

                    this.openCardPaymentComponentNew(newPayment)
                        .then((result: ITDOPaymentTransactionResult) => {

                            if (result?.success) {

                                //  'result.amount' should be same as  'payDr.amount'

                                this.approvedPaymentAmount = result.data.amount;
                                this.paymentAmountNotDistributed = result.data.amount;

                                this.applyPayment = true;

                                if (this.saveCCInfo === 1) {
                                    let saveInfo = `${this.dataPatient.PatientId}|${this.currentARPayment.PaymetnID}|${this.currentARPayment.PaymentProcessorId}`;
                                    saveInfo += this.verbalConsentInfo;
                                    this.saveCardPaymentInfo(saveInfo);
                                    this.saveCCInfo = 0;
                                }
                                // reset payments
                                this.resetApplyPaymentAmounts();
                                // auto apply payment
                                this.autoApplyRemaining();
                            }
                            this.submitPaymentInSuccess = false;
                        }, err => {
                            this.submitPaymentInSuccess = false;
                            this.createMessage('Something went wrong', 'Error');
                            console.log(err);
                        });
                }
                else {

                    // not cc integrated
                    // create payment ledger item
                    this.createLedgerItemForPayment().then((success: any) => {
                        if (success) {
                            this.submitPaymentInSuccess = false;
                        }
                    });
                    // setup to distribute payment
                    this.approvedPaymentAmount = this.paymentAmount;
                    this.paymentAmountNotDistributed = this.paymentAmount;
                    // disable top half of screen
                    this.applyPayment = true;
                    // reset payments
                    this.resetApplyPaymentAmounts();
                    // auto apply payment
                    this.autoApplyRemaining();
                    this.submitPaymentInSuccess = false;
                }
            }
        }, err => {

            this.submitPaymentInSuccess = false;
            console.log(err);
        });
        const yy = 0;
    }


    chargeValPayToken(payToken: DataArPaymentToken) {
        // charge here and then make sure it gets into ledger
        this.ispaymentLoading = true;

        // zoli for valpay
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);
        this.paymentAmount = payDr.amount;

        this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {

            if (newPayment) {
                // cfgARPayment record created
                // record new payment
                this.currentARPayment = newPayment;
                newPayment.PaymentProcessorId = payDr.PaymentProcessorId;

                const enterpriseId = localStorage.getItem('TDOEnterpriseId');
                const transactionIdentifier = enterpriseId.concat('-', newPayment.PaymetnID);

                this.chargeCCToken(this.paymentAmount, transactionIdentifier, payToken)
                    .then((result: CreditCardTokenPaymentResponse) => {
                        if (result?.success) {
                            this.approvedPaymentAmount = result.amount;
                            this.paymentAmountNotDistributed = result.amount;

                            this.ispaymentLoading = false;
                            this.applyPayment = true;

                            // reset payments
                            this.resetApplyPaymentAmounts();

                            // auto apply payment
                            this.autoApplyRemaining();
                        }
                    }, err => {
                        this.createMessage('Something went wrong', 'Error');
                        console.log(err);
                    });
            }
        }, err => {
            console.log(err);
        });

    }


    chargeCCToken(paymentAmount: number, transactionIdentifier: string, payToken: DataArPaymentToken) {
        const promise = new Promise((resolve, reject) => {
            this.arService.processValpayTokenPayment(this.paymentAmount, transactionIdentifier, payToken)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    checkValPayToken() {
        return this.paymentTokens.length > 1 && this.selectedPaymentMethod && this.selectedPaymentMethod.enumARPayementTypeID === EnumARPaymentType.CreditCard;
    }

    returnPaymentAmountFromString(paymentString) {
        let numbersOnly = paymentString;

        if (typeof numbersOnly !== 'string') {
            numbersOnly = '0';
        }

        const patt = /[^(\d+)\.(\d+)]/g;
        numbersOnly = numbersOnly.replace(patt, '');

        const parsedPaymentAmount = parseFloat(numbersOnly);
        return parsedPaymentAmount;
    }

    checkIfTotalIsValid() {
        if (this.paymentAmount) {
            if (this.paymentAmount > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    checkIfPaymentAccountSelected() {
        if (this.selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard && this.currentPaymentProcessorId === '')
            return false;
        if (this.depositARAccountID || this.selectedLedgerItem)
            return true;
        return false;
    }

    createMessage(message, type) {
        if (type.toLowerCase() === "error")
            this.toastr.error(message, null, { timeOut: 7000 });
        else if (type.toLowerCase() === "warning")
            this.toastr.warning(message, null, { timeOut: 7000 });
        else
            this.toastr.success(message, null, { timeOut: 7000 });

    }




    setPaymentMethod() {
        this.saveButtonCaption = 'Save Payment';
        // always set the checkbox for initializing reccurence payment to false.
        this.initializeToken = false;
        this.selectedToken = null;
        this.DocPaymentProcessors = [];

        if (this.selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard) {
            this.dateReceivedMin = new Date();
            this.saveButtonCaption = 'Charge';
            this.isDisabledReceivedDate = true;

            if (this.dateReceivedPayment < this.dateReceivedMin) {
                this.dateReceivedPayment = this.dateReceivedMin;
            }
            // load  dataDoctorARPaymentProcessor for DoctorARLocId
            const drPayment = this.PaymentAmountForDoctors.find(f => f.isSelected === true);
            if (!drPayment) {
                this.createMessage('Please select a Doctor.', 'Error');
                return;
            }
            console.log('CreditCard setPaymentMethod', drPayment);

            const drarlocid = drPayment?.DoctorARLocId;
            if (!drarlocid) {
                this.createMessage('Selected Doctor doesn\'t have valid AR Location.', 'Error');
                return;
            }
            this.setPaymentProcessor(drarlocid);

           
        }
        else {
            this.isDisabledReceivedDate = false;
            this.dateReceivedMin = null;
            this.depositARAccountID = this.selectedPaymentMethod.ARAccountID;
            this.saveButtonCaption = 'Save Payment';
        }

     

    }

    setPaymentProcessor(drarlocid: string) {
        console.log('setPaymentProcessor', drarlocid);
        this.ppService.getPaymentProcessorARLocList(drarlocid).subscribe((results) => {
            console.log('setPaymentProcessor', results);

            this.DocPaymentProcessors = results;
            if (this.DocPaymentProcessors.length > 0) {
                this.currentPaymentProcessorId = this.DocPaymentProcessors[0].PaymentProcessorId;
                this.setDocPaymentProcessor(this.currentPaymentProcessorId);
            }
            else {
                this.currentPaymentProcessorId = '';
                if (this.selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard && this.currentPaymentProcessorId === '')
                    this.createMessage('Doctor doesn\'t have a valid Payment Processor.', 'Error');

            }
        });
    }

    cancelClicked() {
        if (this.approvedPaymentAmount && this.paymentAmountNotDistributed > 0 && this.applyPayment) {
            // payments not all distributed
            const dialogRef = this.dialog.open(ArPaymentCancelComponent, {
                width: '650px',
                height: '250px',
                data: {
                    paymentAmount: this.approvedPaymentAmount,
                    arPaymentID: this.currentARPayment.PaymetnID
                }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.dialogRef.close(result);
                }
            }, err => {
            });
        }
        else {
            // close window
            this.dialogRef.close();
        }
    }

    getPaymentProcessorDevicesByWorkstation(WorkstationID: string, LOCID: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.getPaymentProcessorDevicesByWorkstation(WorkstationID, LOCID)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    getPaymentProcessorList(LOCID: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.getPaymentProcessorList(LOCID)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    getAllDoctorARLocations() {
        const promise = new Promise((resolve, reject) => {
            this.arService.getAllDoctorARLocations()
                .subscribe(resolve, reject);
        });
        return promise;
    }

    getAllARAccounts() {
        const promise = new Promise((resolve, reject) => {
            this.arService.getAllARAccounts()
                .subscribe(resolve, reject);
        });
        return promise;
    }

    returnARAccountName(DoctorARLocId: string) {
        let ARAccountName: string = '';
        this.arAccounts.forEach(a => {
            if (a.DoctorARLocId === DoctorARLocId) {
                ARAccountName = a.AccountName;
            }
        });

        return ARAccountName;
    }

    returnARAccountNameById(ARAccountID: string) {
        let ARAccountName: string = '';
        this.arAccounts.forEach(a => {
            if (a.ARAccountID === ARAccountID) {
                ARAccountName = a.AccountName;
            }
        });
        return ARAccountName;
    }

    async returnValidPaymentTokens() {
        // make call here to check on payment tokens for patient
        const promise = new Promise((resolve, reject) => {
            this.arService.getPaymentTokenForPatient(this.dataPatient.PatientId)
                .subscribe(resolve, reject);
        });
        await promise.then((result: DataArPaymentToken[]) => this.paymentTokens = result);
        const addNew = new DataArPaymentToken();
        addNew.Description = 'Add New Token';
        this.paymentTokens.push(addNew);
    }

    updateEPaymentTypes() {
        this.paymentESources = [];
        if (this.selectedPaymentType.ValidValueItemId === EnumARPaymentType.CreditCard) {
            // show paymentEtypes for electronic - debit, credit
            this.paymentESourcesMaster.forEach(a => {
                if (a.ValidValueItemId === this.enumPaymentETypeCreditCard
                    || a.ValidValueItemId === this.enumPaymentETypeDebitCard) {
                    this.paymentESources.push(a);
                }
            });
        }
        else if (this.selectedPaymentType.ValidValueItemId === EnumARPaymentType.CreditCardOffline) {
            // show paymentEtypes for electronic - debit, credit
            this.paymentESourcesMaster.forEach(a => {
                if (a.ValidValueItemId === this.enumPaymentETypeCreditCard
                    || a.ValidValueItemId === this.enumPaymentETypeDebitCard
                    || a.ValidValueItemId === this.enumPaymentETypeCareCredit
                    || a.ValidValueItemId === this.enumPaymentETypeECheck) {
                    this.paymentESources.push(a);
                }
            });
        }
    }

    clearDistributions() {
        // reset payment distributions
        this.resetApplyPaymentAmounts();
        this.setPaymentAmountDistributionRemaining();
    }

    // openPaymentProcessorDeviceComponent() {
    //     const promise = new Promise((resolve, reject) => {

    //         const dialogRef = this.dialog.open(ArTriposTerminalPaymentComponent, {
    //             panelClass: 'dialog',
    //             data: {
    //                 Amount: this.paymentAmount,
    //                 Action: 1,
    //                 PaymentID: this.currentARPayment.PaymetnID,
    //                 EnumPaymentSourceID: this.currentARPayment.enumPaymentSourceID,
    //                 DescriptionLong: this.paymentDescription,
    //                 DescriptionPinPad: '',
    //                 PaymentProcessorID: this.paymentDevices[0].PaymentProcessorId,
    //                 PaymentDeviceID: this.paymentDevices[0].PaymentDeviceID,
    //                 PayerName: this.selectedContact.FirstName + ' ' + this.selectedContact.LastName,
    //                 PatientName: this.dataPatient.dataContact.FirstName + ' ' + this.dataPatient.dataContact.LastName,
    //                 PaymentProcessorDeviceList: this.paymentDevices,
    //                 enumARProcessorID: this.paymentDevices[0].enumARProcessorID
    //             }
    //         });
    //         dialogRef.afterClosed().subscribe(result => {

    //         }, err => {
    //             console.log(err);
    //         });
    //     });
    //     return promise;
    // }

    openCardPaymentComponentNew(payment: DataARPaymentModel) {

        const promise = new Promise((resolve, reject) => {

            const LOCID = localStorage.getItem('LOCID');
            const dialogRef = this.dialog.open(ArCardPaymentComponent, {
                // width: '650px',
                // height: '500px',
                disableClose: true,
                panelClass: 'dialog',
                data: {
                    paymentAmount: payment.PaymentAmount,
                    LOCID,
                    arPayment: payment,
                    paymentFrom: this.selectedContact.FirstName + ' ' + this.selectedContact.LastName,
                    accountDescription: this.returnARAccountNameById(this.depositARAccountID),
                    paymentProcessorID: payment.PaymentProcessorId,
                    savePaymentInfo: this.saveCCInfo
                }
            });
            dialogRef.afterClosed().subscribe(result => {

                resolve(result);
            }, err => {
            });

        });
        return promise;
    }

    OpenCardPaymentConsent() {
        this.saveCCInfo = 1;
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);
        this.paymentAmount = payDr.amount; // check if this is zero otherwise throw error up a screen
        if (this.paymentAmount <= 0) {
            this.createMessage('Selected Payment Amount is $0.00', 'Error');
            return;
        }
        // console.log(this.paymentAmount);
        const promise = new Promise((resolve, reject) => {


            const dialogRef = this.dialog.open(ArPaymentTokenConsentComponent, {

                disableClose: true,
                panelClass: 'dialog',
                data: {
                    amount: this.paymentAmount,
                    patient: this.dataPatient,
                    patientId: this.dataPatient.PatientId
                }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result && Array.isArray(result)) {
                    const expirationDate = result[0];
                    this.verbalConsentInfo = `|${expirationDate}`;
                    if (result.length === 2) {
                        const contactId = result[1];
                        this.verbalConsentInfo += `|${contactId}`;
                    }
                    this.submitPayment('press');
                    resolve(result);
                } else {
                    resolve(result);
                }
            }, err => {
            });

        });
        return promise;
    }

    saveCardPaymentInfo(tokenInfo: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.saveCCPaymentTokenInfo(tokenInfo)
                .subscribe(resolve, reject);
        });
        return promise;
    }


    createPaymentDistribution(ledgerID: string) {
        const promise = new Promise((resolve, reject) => {

            // create credit for approved payment amount
            const paymentDist = new DataARPaymentDistribsModel();
            paymentDist.Amount = this.paymentAmountNotDistributed;
            paymentDist.PaymetnID = this.data.arPaymentID;
            paymentDist.LedgerID = ledgerID;

            this.arService.CreatePaymentDistribution(paymentDist)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    async createCreditForUndistributedPayment() {

        try {

            // credit ledger item
            const ledgerItemCredit = new DataARLedgerModel();
            ledgerItemCredit.LOCID = parseInt(localStorage.getItem('LOCID'));
            ledgerItemCredit.PatientId = this.globals.currentPatientId;
            ledgerItemCredit.PostDate = new Date();
            ledgerItemCredit.Amount = this.paymentAmountNotDistributed;
            ledgerItemCredit.Description = 'Undistributed payment credit - Administrative';
            ledgerItemCredit.Reference = 'Overpay Conversion';
            ledgerItemCredit.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditAdjustment;
            ledgerItemCredit.enumARLedgerItemOriginTypeID = this.enumLedgerItemOriginTypePatient;
            ledgerItemCredit.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;
            ledgerItemCredit.PaymetnID = this.currentARPayment.PaymetnID;

            // should we set the doctorARLOCID?
            // ledgerItemCredit.DoctorARLocId = null;

            await this.arService.saveLedgerItem(ledgerItemCredit).toPromise();
            this.createMessage('Credit created for undistributed payment amount', 'Success');
            this.isLoading = false;
            this.close(true);
        } catch (err) {
            console.log('err', err);
            this.createMessage('Credit not created', 'Error');
            this.isLoading = false;
        }
    }

    openChooseLedgerItemWindow() {
        const dialogRef = this.dialog.open(ArLedgerItemSelectComponent, {
            panelClass: 'dialog',
            autoFocus: false,
            data: {
                dataLedgerItems: this.dataCreditLedgerItems,
                isShowCredits: true
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.selectedLedgerItem = result;
                this.paymentAmount = this.selectedLedgerItem.Amount;
                this.selectedPaymentMethod = null;
                this.depositARAccountID = null;

                // set flag to show that we are applying a credit
                // for now if this.selectedLedgerItem has a value then we are assuming that a credit is being used
            }
        }, err => {
        });
    }

    PaymentAmountForDoctorSelection(charge: PaymentAmountForDoctorModel) {

        console.log("PaymentAmountForDoctorSelection: ", charge);
        this.PaymentAmountForDoctors.forEach(d => {
            if (d.DoctorARLocId === charge.DoctorARLocId) {
                d.isSelected = charge.isSelected;
            }
            else {
                d.isSelected = false;
            }

            if (d.isSelected === true) {
                this.depositARAccountID = d.ARAccountID;
                this.setPaymentProcessor(d.DoctorARLocId);
            }
        });
    }

    setDocPaymentProcessor(paymentProcessorId: string) {
        this.currentPaymentProcessorId = paymentProcessorId;
        const dr = this.PaymentAmountForDoctors.find(f => f.isSelected);
        dr.PaymentProcessorId = paymentProcessorId;
    }

    async openPaymentReceipt() {
        this.isPrintingReceipt = true;
        const paymentPrintParameters = new PrintCCReceiptModel();
        paymentPrintParameters.PatientID = this.globals.currentPatientId;
        paymentPrintParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
        paymentPrintParameters.LOCID = this.globals.LOCID;
        paymentPrintParameters.TDOCID = localStorage.getItem('TDOCID');
        paymentPrintParameters.PaymentID = this.currentARPayment.PaymetnID;
        try {
            const documentID = await this.printService.printReport(ReportIDEnum.reportID_CreditCardReceiptReport, paymentPrintParameters).toPromise();
            this.printService.executePrint([documentID]);
            this.isPrintingReceipt = false;
        }
        catch (error) {
            this.createMessage('Error when trying to print Document.', 'error');
            this.isPrintingReceipt = false;
        }
    }
}
